import { cn } from '#/lib/utils';

/** 出庫雙欄：統計 label（需求／剩餘／已選／可用） */
export const OUTBOUND_QTY_STAT_LABEL_CLASS = 'text-xs text-muted-foreground';

/** 出庫雙欄：統計 value 預設（襯線數字、medium） */
export const OUTBOUND_QTY_STAT_VALUE_CLASS = (
  'text-sm font-medium tabular-nums text-slate-800'
);

/** 出庫雙欄：數量 value min-w（萬位 5ch；超過可自然增長） */
export const OUTBOUND_QTY_STAT_VALUE_QTY_MIN_WIDTH_CLASS = (
  'inline-block min-w-[5ch] text-right'
);

/** 出庫雙欄：計數 value（已選 N 筆；不撐寬） */
export const OUTBOUND_QTY_STAT_VALUE_COUNT_MIN_WIDTH_CLASS = '';

/** 出庫已選列：操作數量 Input 尺寸 */
export const OUTBOUND_QTY_INPUT_CLASS = 'h-9 w-20';

/** 剩餘量 > 0：警示紅；≤ 0：primary 藍 */
export function getOutboundRemainingQtyValueClass(remainingQty) {
  const n = Number(remainingQty);
  if (Number.isFinite(n) && n > 0) {
    return 'text-red-600';
  }
  return 'text-primary-600';
}

export function outboundQtyStatValueClassName(extraClassName) {
  return cn(OUTBOUND_QTY_STAT_VALUE_CLASS, extraClassName);
}
